import { ducter_energyServices } from '../axios_ducter_energy'

const api_ducter_energy = {}


api_ducter_energy.updateProgram = async function (form) {
  const options = {
    method: 'POST',
    url: '/program-update-status',
    headers: {'Content-Type': 'application/json', Accept: 'application/json'},
    data: form
  }

  const data = await ducter_energyServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

api_ducter_energy.version = async function () {
  const data = await ducter_energyServices.get(``)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}




export default api_ducter_energy



// WEBPACK FOOTER //
// ./src/services/sca/apiDucterEnergy.js